import { gql } from "@apollo/client";
import { useState } from "react";
import { useQuery } from "@apollo/client";
import useAuth from "~/src/auth/hooks/use-auth";
import { checkErrors } from "~/src/utils/errors";
import { PayrollBreak } from "../types";

type dataType = {
  account: {
    payrollBreaks: PayrollBreak[];
  };
};

export const GET_PAYROLL_BREAKS = gql`
  query payrollBreaks($search: String, $offset: Int!, $limit: Int!) {
    account {
      id
      payrollBreaks(search: $search, offset: $offset, limit: $limit) {
        id
        name
        config
        createdAt
        updatedAt
      }
    }
  }
`;

const PAGE_SIZE = 200;

export const usePayrollBreaks = (searchText: string) => {
  const auth = useAuth();
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [offset, setOffset] = useState(0);

  const { loading, data, fetchMore } = checkErrors(
    useQuery(GET_PAYROLL_BREAKS, {
      variables: auth.addVals(GET_PAYROLL_BREAKS, {
        search: searchText,
        offset,
        limit
      }),
      fetchPolicy: isInitialFetch ? "network-only" : "cache-first",
      notifyOnNetworkStatusChange: true
    })
  );

  const payrollBreaks = data?.account?.payrollBreaks ?? [];
  const totalResults = payrollBreaks.length;

  return {
    loading: isInitialFetch && loading,
    loadingMore: !isInitialFetch && loading,
    payrollBreaks,
    hasMore: payrollBreaks.length < totalResults,
    fetchMore: () => {
      if (payrollBreaks.length < totalResults) {
        setIsInitialFetch(false);
        const newOffset = offset + limit;
        setOffset(newOffset);

        fetchMore({
          variables: {
            offset: newOffset,
            limit: PAGE_SIZE
          },
          fetchPolicy: "network-only"
        }).then(({ data }: { data: dataType }) => {
          setLimit(limit + data.account.payrollBreaks.length);
        });
      }
    }
  };
};
